import React from 'react'
import Button from 'components/ui/button'
import styles from './index.module.css'

const specialTypes = ['Label', 'Publisher']

const ContactCard = ({
  title,
  action,
  children,
}: {
  title?: string
  action?: {
    content: string
    disabled?: boolean
    link?: string
    onClick: () => void
  }
  children?: React.ReactNode
}) => {
  // let position = ''
  // if (type && type !== 'Other' && company) {
  //   position = specialTypes.includes(type)
  //     ? `${company} (${type.toLowerCase()})`
  //     : `${type} at ${company}`
  // } else if (company) {
  //   position = company
  // }
  return (
    <div className={styles.contactCard}>
      {title && <div className={styles.contactCardTitle}>{title}</div>}
      {children && <div className={styles.contactCardContent}>{children}</div>}
      {action && (
        <div className={styles.contactCardAction}>
          <Button
            caption={action.content}
            disabled={action.disabled}
            link={action.link}
            onClick={action.onClick}
          />
        </div>
      )}
    </div>
  )
}

export default ContactCard
